import String from "../../../assets/images/text_fields.svg";
import Number from "../../../assets/images/123.svg";
import Boolean from "../../../assets/images/rule.svg";
import Complex from "../../../assets/images/interrogation.svg";

const CorrespondanceTypeImage = (type: string): string | undefined => {
  switch (type) {
    case "string":
      return String;
    case "long":
      return Number;
    case "int":
      return Number;
    case "number":
      return Number;
    case "bytes":
      return Number;
    case "double":
      return Number;
    case "float":
      return Number;
    case "boolean":
      return Boolean;
    case "":
      return Complex;

    default:
      return Complex;
  }
};

export default CorrespondanceTypeImage;
